import React, { useEffect } from "react";
import { ColumnsType } from "antd/es/table";
import { Table } from "antd";
import { ICustomerAccountSummary } from "../../../AccountTypes";
import { useSummaryModel } from "./summaryModel";

const columns: ColumnsType<ICustomerAccountSummary> = [
    {
        align: "center",
        width: 100,
        ellipsis: true,
        title: "分支",
        dataIndex: "branch"
    },
    {
        align: "center",
        width: 300,
        ellipsis: true,
        title: '客户名称',
        dataIndex: 'name',
    },
    {
        align: "center",
        width: 200,
        ellipsis: true,
        title: '客户编码',
        dataIndex: 'code',
    },
    {
        align: "center",
        width: 100,
        ellipsis: true,
        title: '客户类型',
        dataIndex: 'categoryName',
    },
    {
        align: "center",
        width: 100,
        ellipsis: true,
        title: '授信额度',
        dataIndex: 'totalCreditAmount',
    },
    {
        align: "center",
        width: 100,
        ellipsis: true,
        title: '已用额度',
        dataIndex: 'totalUsedAmount',
    },
    {
        align: "center",
        width: 100,
        ellipsis: true,
        title: '可用额度',
        dataIndex: 'totalAvailableAmount',
    },
    {
        align: "center",
        width: 100,
        ellipsis: true,
        title: '剩余总额',
        dataIndex: 'totalRemainingAmount',
    },
    {
        align: "center",
        width: 100,
        ellipsis: true,
        title: '欠款',
        dataIndex: 'totalDebtAmount',
    },
    // {
    //     title: '从属机构',
    //     dataIndex: 'orgName',
    // },

];

export function DataTable() {
    const {
        dataSource, selectedRowKeys, pgCfg,
        loadData, setSelectedRowKeys,initPgCfg,setSearchParam
    } = useSummaryModel(model => [model.dataSource, model.selectedRowKeys]);
    useEffect(() => {
        setSearchParam({});
        loadData(initPgCfg, {})
    }, [])

    //点击行选高亮
    const onRow = (record: ICustomerAccountSummary) => {
        let findObj = selectedRowKeys.find(item => item.key === record.key)
        if (findObj) {
            let newSelectedRowKeys = selectedRowKeys.filter(item => item.key !== record.key);
            setSelectedRowKeys(newSelectedRowKeys);
        } else {
            setSelectedRowKeys(origin => [...origin, record]);
        }
    };

    return (
        <Table
            rowSelection={{
                //全部选中时 (存row[])
                onSelectAll: (selected, selectedRows, changeRows) => {
                    selected ? setSelectedRowKeys((origin) => [...origin, ...changeRows])
                        : setSelectedRowKeys((origin) => {
                            let changeRowId = changeRows.map(item => item.key);
                            return origin.filter(item => changeRowId.indexOf(item.key) < 0)
                        });
                },
                onSelect: (record, selected, selectedRows) => onRow(record),
                selectedRowKeys: selectedRowKeys.map(item => item.key)
            }}
            columns={columns}
            dataSource={dataSource}
            pagination={{
                ...pgCfg,
                showTotal: (total: number) => `共${total}条`,
                position: ["bottomCenter"],
                onChange: (pageNum, pageSize) => {
                    loadData({ pageNum, pageSize })
                }
            }}
            onRow={record => ({
                onClick: () => onRow(record),
                onContextMenu: (e) => {
                    e.preventDefault();
                    setSelectedRowKeys([record]);
                }
            })}
            scroll={{ x: 'max-content', y: 'calc(100vh - 400px)' }}
        />
    )
}

